import React, { useEffect, useState } from "react";

export function ProgressRing({ size = 120, strokeWidth = 10, progress, done, total }) {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const [animatedOffset, setAnimatedOffset] = useState(circumference);

  useEffect(() => {
    // Small delay for animation trigger
    const timer = setTimeout(() => {
      setAnimatedOffset(circumference * (1 - progress));
    }, 100);
    return () => clearTimeout(timer);
  }, [progress, circumference]);

  const pct = Math.round(progress * 100);
  const color = progress >= 1 ? "hsl(var(--success))" : "hsl(var(--primary))";

  return (
    <div className="relative flex-shrink-0" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        {/* Track */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="hsl(var(--border))"
          strokeWidth={strokeWidth}
        />
        {/* Progress */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={animatedOffset}
          style={{ transition: 'stroke-dashoffset 0.8s cubic-bezier(0.4, 0, 0.2, 1), stroke 0.3s ease' }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-bold text-2xl tracking-tight" style={{ color }}>{pct}%</span>
        <span className="text-foreground font-semibold text-xs mt-0.5">{done} / {total}</span>
        <span className="text-muted-foreground text-[5px] uppercase tracking-[0.08em] mt-0.5">completadas</span>
      </div>
    </div>
  );
}
